import { createApp } from 'vue';
import router from './router.js';
import App from './App.vue';
import '@/assets/styles/index.css';
import '@/assets/styles/tailwind.css';

const app = createApp(App);
app.use(router).mount('#app');
